export default __webpack_public_path__ + "static/media/Immagine_7.dfd7befb.jpg";